export default {
    SET_REASONS: (state, reasons) => {
        state.reasons = reasons;
    },

    SET_CARDS: (state, cards) => {
        state.cards = cards;
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination;
    },

    SET_ACTIVE_INFO_NAV: (state, nav) => {
        state.activeInfoNav = nav;
    },

    SET_PAYMENTS: (state, payments) => {
        state.payments = payments;
    },

    SET_FP_PAYMENTS: (state, fpPayments) => {
        state.fpPayments = fpPayments;
    },

    SET_CLIENT_INFO: (state, { fromFp = false, ...clientInfo }) => {
        if (fromFp) {
            return state.fpClientInfo = clientInfo;
        }

        const keys = Object.keys(state.clientInfo);

        state.clientInfo = {
            ...Object.select(clientInfo, keys),
            company: !!clientInfo.corporation
                && clientInfo.corporation.company
        };
    },

    RESET_CLIENT_INFO: (state) => {
        state.clientInfo = {
            user: null,
            company: null,
            bonusSystem: null,
            orders: []
        };
    },

    RESET_FP_CLIENT_INFO: (state) => {
        state.fpClientInfo = {
            cashback: null,
            balanceHistory: []
        };
    },

    SET_CARD_DATA: (state, cardData) => {
        state.cardData = cardData;
        localStorage.setItem('card', JSON.stringify(cardData));
    }
};
